(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marketing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Ken Burns effect if enabled
  const bannerSection = document.querySelector('.banner-section[data-ken-burns="true"]');
  if (bannerSection) {
    const images = bannerSection.querySelectorAll('.banner-image__img');
    images.forEach(img => {
      img.classList.add('ken-burns-active');
    });
  }

  // Fade in animation for text elements with staggered delays
  const animateElements = document.querySelectorAll('.animate--fade-in');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add small timeout to ensure smooth animation start after page load
        setTimeout(() => {
          entry.target.classList.add('animate--visible');
        }, 100);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  animateElements.forEach(el => {
    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
/** 
 * 商品滑块功能 - 优化版
 * 遵循 Shopify 最佳实践
 */

// 使用 IIFE 创建模块化代码，避免全局污染
(function() {
  // 全局变量和状态管理
  const state = {
    cartNeedsRefresh: false,
    totalItems: 0,
    isUpdatingCart: false
  };
  
  // 基础工具函数
  const utils = {
    // 货币格式化工具
    formatMoney: function(cents, format) {
      if (!window.Shopify || typeof window.Shopify.formatMoney !== 'function') {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        
        const value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || '¥{{amount}}';
        
        function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
        }
        
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');
          
          if (isNaN(number) || number == null) {
            return 0;
          }
          
          number = (number / 100.0).toFixed(precision);
          
          const parts = number.split('.');
          const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          const cents = parts[1] ? (decimal + parts[1]) : '';
          
          return dollars + cents;
        }
        
        let formattedValue;
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            formattedValue = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            formattedValue = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            formattedValue = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            formattedValue = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
        
        return formatString.replace(placeholderRegex, formattedValue);
      } else {
        return window.Shopify.formatMoney(cents, format);
      }
    },
    
    // 防抖动函数 - 避免频繁触发事件
    debounce: function(func, wait, immediate) {
      let timeout;
      return function() {
        const context = this, args = arguments;
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    
    // DOM 选择器辅助函数
    select: function(selector, parent = document) {
      return parent.querySelector(selector);
    },
    
    selectAll: function(selector, parent = document) {
      return Array.from(parent.querySelectorAll(selector));
    }
  };
  
  // 购物车 API 模块 - 整合所有购物车相关操作
  const cartAPI = {
    // 获取购物车数据
    getCart: async function() {
      try {
        const response = await fetch('/cart.js?t=' + new Date().getTime(), {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });
        
        if (!response.ok) throw new Error('获取购物车数据失败');
        return await response.json();
      } catch (error) {
        console.error('获取购物车数据出错:', error);
        throw error;
      }
    },
    
    // 添加商品到购物车
    addToCart: async function(variantId, quantity = 1, properties = null) {
      try {
        const data = {
          items: [{
            id: variantId,
            quantity: quantity
          }]
        };
        
        // 添加自定义属性，如果提供
        if (properties) {
          data.items[0].properties = properties;
        }
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(data)
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || '添加到购物车失败');
        }
        
        // 成功添加后标记购物车需要刷新
        state.cartNeedsRefresh = true;
        
        return await response.json();
      } catch (error) {
        console.error('添加商品到购物车出错:', error);
        throw error;
      }
    },
    
    // 更新购物车计数
    updateCartCount: async function() {
      try {
        const cartData = await this.getCart();
        state.totalItems = cartData.item_count;
        
        // 更新所有购物车计数显示
        utils.selectAll('.cart-count, .cart-count-bubble, [data-cart-count]').forEach(el => {
          el.textContent = cartData.item_count;
          if (el.classList.contains('hidden') && cartData.item_count > 0) {
            el.classList.remove('hidden');
          } else if (cartData.item_count === 0 && !el.classList.contains('hidden')) {
            el.classList.add('hidden');
          }
          
          // 添加动画效果
          el.classList.add('animate-pulse');
          setTimeout(() => el.classList.remove('animate-pulse'), 1000);
        });
        
        // 触发自定义事件
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { cart: cartData }
        }));
        
        return cartData;
      } catch (error) {
        console.error('更新购物车计数出错:', error);
      }
    },
    
    // 刷新购物车抽屉内容
    refreshCartDrawer: async function(retry = 0) {
      // 避免多次同时刷新
      if (state.isUpdatingCart) return;
      
      state.isUpdatingCart = true;
      
      try {
        // 获取最新购物车数据
        const cartData = await this.getCart();
        
        // 查找可能的购物车容器
        const cartContainers = utils.selectAll(
          '.cart-drawer__content, .cart-dropdown__content, .cart__contents, [data-cart-content], .cart-drawer, .mini-cart, .site-cart'
        );
        
        if (cartContainers.length === 0 && retry < 1) {
          // 可能购物车尚未打开，尝试打开
          if (window.theme) {
            if (typeof window.theme.openCartDrawer === 'function') {
              window.theme.openCartDrawer();
            } else if (window.theme.cart && typeof window.theme.cart.open === 'function') {
              window.theme.cart.open();
            }
          }
          
          // 短暂延迟后再次尝试
          setTimeout(() => {
            state.isUpdatingCart = false;
            this.refreshCartDrawer(retry + 1);
          }, 500);
          return;
        }
        
        // 尝试通过 Shopify 主题的内置方法更新
        let updated = false;
        if (window.theme) {
          if (typeof window.theme.updateCartDrawer === 'function') {
            window.theme.updateCartDrawer(cartData);
            updated = true;
          } else if (typeof window.theme.refreshCart === 'function') {
            window.theme.refreshCart(cartData);
            updated = true;
          } else if (window.theme.cart && typeof window.theme.cart.refresh === 'function') {
            window.theme.cart.refresh(cartData);
            updated = true;
          }
        }
        
        // 如果找到容器但无法通过主题方法更新，尝试获取购物车HTML
        if (!updated && cartContainers.length > 0) {
          try {
            const response = await fetch('/cart?view=drawer&t=' + new Date().getTime(), {
              headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0'
              }
            });
            
            if (!response.ok) throw new Error('获取购物车HTML内容失败');
            
            let html = await response.text();
            if (html.trim() === '') {
              throw new Error('购物车HTML内容为空');
            }
            
            // 处理HTML内容并更新容器
            let safeHtml;
            try {
              // 移除可能引起错误的脚本标签
              safeHtml = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
            } catch (e) {
              console.warn('清理HTML内容时出错', e);
              safeHtml = html;
            }
            
            // 更新购物车内容
            cartContainers.forEach(container => {
              try {
                container.innerHTML = safeHtml;
                
                // 处理价格显示
                utils.selectAll('[data-price], .cart-item__price, .cart-item__total', container).forEach(priceEl => {
                  if (priceEl.dataset.price) {
                    try {
                      const price = parseInt(priceEl.dataset.price, 10);
                      if (!isNaN(price)) {
                        priceEl.textContent = utils.formatMoney(price);
                      }
                    } catch (priceErr) {
                      console.warn('格式化价格时出错', priceErr);
                    }
                  }
                });
              } catch (containerError) {
                console.warn('更新购物车容器时出错', containerError);
              }
            });
          } catch (htmlError) {
            console.error('获取购物车HTML时出错:', htmlError);
          }
        }
        
        // 重置购物车更新状态标志
        state.cartNeedsRefresh = false;
        
      } catch (error) {
        console.error('刷新购物车抽屉出错:', error);
      } finally {
        state.isUpdatingCart = false;
      }
    }
  };
  
  // 购物车图标交互模块
  const cartIconInteraction = {
    // 初始化
    init: function() {
      this.setupCartIconListeners();
      this.observeDOM();
    },
    
    // 设置购物车图标点击监听
    setupCartIconListeners: function() {
      const cartIcons = utils.selectAll(
        '.cart-icon, .cart-link, [data-cart-toggle], [data-toggle="cart"], [href*="/cart"], [aria-controls*="cart-drawer"], [data-cart-drawer-toggle], #cart-icon-bubble, .site-header__cart'
      );
      
      if (cartIcons.length > 0) {
        cartIcons.forEach(icon => {
          // 如果已经设置过监听，跳过
          if (icon.hasAttribute('data-cart-listener-attached')) return;
          
          // 保存原始点击处理函数
          const originalClickHandler = icon.onclick;
          
          // 设置新的点击处理函数
          icon.onclick = async function(e) {
            // 如果购物车需要刷新，先刷新内容
            if (state.cartNeedsRefresh) {
              e.preventDefault();
              e.stopPropagation();
              
              try {
                // 刷新购物车内容
                await cartAPI.refreshCartDrawer();
                
                // 处理原始点击事件
                if (originalClickHandler) {
                  originalClickHandler.call(this, e);
                } else {
                  // 如果没有原始点击事件，模拟默认行为
                  if (this.tagName === 'A' && this.href) {
                    if (this.href.includes('/cart')) {
                      this.click();
                    }
                  } else {
                    // 尝试查找并点击关联的购物车开关
                    const drawerToggles = utils.selectAll('[data-drawer-toggle="cart"], [aria-controls="cart-drawer"]');
                    if (drawerToggles.length > 0) {
                      drawerToggles[0].click();
                    }
                  }
                }
              } catch (error) {
                console.error('刷新购物车失败:', error);
                // 出错时继续执行原始点击事件
                if (originalClickHandler) {
                  originalClickHandler.call(this, e);
                }
              }
              return false;
            }
            
            // 如果不需要刷新，执行原始点击处理
            if (originalClickHandler) {
              return originalClickHandler.call(this, e);
            }
          };
          
          // 标记已添加监听
          icon.setAttribute('data-cart-listener-attached', 'true');
          
          // 添加键盘可访问性支持
          if (!icon.hasAttribute('tabindex')) {
            icon.setAttribute('tabindex', '0');
          }
          
          if (!icon.hasAttribute('role')) {
            icon.setAttribute('role', 'button');
          }
          
          if (!icon.hasAttribute('aria-label')) {
            icon.setAttribute('aria-label', '查看购物车');
          }
          
          // 添加键盘事件监听
          icon.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
        });
      }
    },
    
    // DOM 变化监听，动态处理新添加的购物车图标
    observeDOM: function() {
      const observer = new MutationObserver(
        utils.debounce(() => {
          this.setupCartIconListeners();
        }, 300)
      );
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };
  
  // 滑块功能模块
  const productSlider = {
    // 初始化滑块
    init: function() {
      const sliders = utils.selectAll('.products-slider');
      
      sliders.forEach(slider => {
        this.initializeSlider(slider);
      });
    },
    
    // 初始化单个滑块
    initializeSlider: function(slider) {
      const wrapper = slider.closest('.slider-wrapper');
      if (!wrapper) return;
      
      const container = wrapper.closest('.slider-outer-wrapper');
      if (!container) return;
      
      const prevBtn = utils.select('.slider-prev', container);
      const nextBtn = utils.select('.slider-next', container);
      
      if (!prevBtn || !nextBtn) return;
      
      // 配置参数
      const slideBy = slider.clientWidth / 2; // 每次滑动屏幕宽度的一半
      
      // 添加可访问性支持
      slider.setAttribute('role', 'region');
      slider.setAttribute('aria-label', '商品滑块');
      
      // 检查按钮状态
      const checkButtonState = () => {
        // 左侧按钮状态
        if (slider.scrollLeft <= 10) {
          prevBtn.classList.add('disabled');
          prevBtn.setAttribute('aria-disabled', 'true');
        } else {
          prevBtn.classList.remove('disabled');
          prevBtn.setAttribute('aria-disabled', 'false');
        }
        
        // 右侧按钮状态
        if (Math.ceil(slider.scrollLeft + slider.clientWidth) >= slider.scrollWidth - 10) {
          nextBtn.classList.add('disabled');
          nextBtn.setAttribute('aria-disabled', 'true');
        } else {
          nextBtn.classList.remove('disabled');
          nextBtn.setAttribute('aria-disabled', 'false');
        }
      };
      
      // 添加滑动功能
      const scrollToNext = () => {
        slider.scrollBy({
          left: slideBy,
          behavior: 'smooth'
        });
      };
      
      const scrollToPrev = () => {
        slider.scrollBy({
          left: -slideBy,
          behavior: 'smooth'
        });
      };
      
      // 添加事件监听
      prevBtn.addEventListener('click', scrollToPrev);
      nextBtn.addEventListener('click', scrollToPrev);
      
      // 键盘导航支持
      prevBtn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToPrev();
        }
      });
      
      nextBtn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToNext();
        }
      });
      
      // 滚动事件监听
      slider.addEventListener('scroll', utils.debounce(checkButtonState, 100));
      
      // 窗口大小变化监听
      window.addEventListener('resize', utils.debounce(() => {
        checkButtonState();
      }, 200));
      
      // 触摸滑动支持
      let startX, startScrollLeft;
      
      slider.addEventListener('touchstart', e => {
        startX = e.touches[0].pageX;
        startScrollLeft = slider.scrollLeft;
      }, { passive: true });
      
      slider.addEventListener('touchmove', e => {
        const x = e.touches[0].pageX;
        const dist = startX - x;
        slider.scrollLeft = startScrollLeft + dist;
      }, { passive: true });
      
      // 初始化按钮状态
      checkButtonState();
      
      // 初始化快速添加按钮
      this.initializeQuickAddButtons(slider);
    },
    
    // 初始化快速添加按钮
    initializeQuickAddButtons: function(slider) {
      const quickAddButtons = utils.selectAll('.product-quick-add-btn', slider);
      
      quickAddButtons.forEach(button => {
        // 如果已经设置过监听，跳过
        if (button.hasAttribute('data-quick-add-initialized')) return;
        
        // 确保可访问性
        if (!button.hasAttribute('aria-label')) {
          button.setAttribute('aria-label', '快速添加到购物车');
        }
        
        // 添加点击事件监听
        button.addEventListener('click', async function(e) {
          e.preventDefault();
          
          const variantId = this.dataset.variantId;
          if (!variantId) return;
          
          // 设置加载状态
          this.disabled = true;
          const originalText = "快速添加";
          this.textContent = '添加中...';
          this.setAttribute('aria-busy', 'true');
          
          try {
            // 添加到购物车
            await cartAPI.addToCart(variantId);
            
            // 设置成功状态
            this.textContent = '已添加 ✓';
            this.setAttribute('aria-busy', 'false');
            
            // 刷新购物车计数
            await cartAPI.updateCartCount();
            
            // 延迟后恢复按钮状态
            setTimeout(() => {
              this.textContent = originalText;
              this.disabled = false;
            }, 2000);
            
          } catch (error) {
            // 处理错误
            console.error('添加到购物车失败:', error);
            this.textContent = '添加失败';
            this.setAttribute('aria-busy', 'false');
            
            // 延迟后恢复按钮状态
            setTimeout(() => {
              this.textContent = originalText;
              this.disabled = false;
            }, 2000);
          }
        });
        
        // 标记已初始化
        button.setAttribute('data-quick-add-initialized', 'true');
      });
    }
  };
  
  // 初始化应用
  function initApp() {
    // 确保Shopify对象存在
    window.Shopify = window.Shopify || {};
    
    // 公开必要的API
    window.ProductSlider = {
      refreshCart: cartAPI.refreshCartDrawer.bind(cartAPI),
      addToCart: cartAPI.addToCart.bind(cartAPI),
      getCart: cartAPI.getCart.bind(cartAPI)
    };
    
    // 暴露状态属性
    Object.defineProperty(window, 'cartNeedsRefresh', {
      get: function() { return state.cartNeedsRefresh; },
      set: function(value) { state.cartNeedsRefresh = value; }
    });
    
    Object.defineProperty(window, 'totalItems', {
      get: function() { return state.totalItems; },
      set: function(value) { state.totalItems = value; }
    });
    
    // 初始化各模块
    cartIconInteraction.init();
    productSlider.init();
  }
  
  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
  } else {
    initApp();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-storage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
  var seeMoreBtn = document.getElementById("see-more-btn");
  var seeLessBtn = document.getElementById("see-less-btn");
  var textContainer = document.getElementById("text-content");

  var fullText = textContainer.innerHTML;
  var wordCount = fullText.split(' ').length;

  if (wordCount <= 100) {
    seeMoreBtn.style.display = "none";
  } else {
    var previewText = fullText.split(' ').slice(0, 100).join(' ') + '...';
    textContainer.innerHTML = previewText;
  }

  seeMoreBtn.addEventListener("click", function() {
    textContainer.innerHTML = fullText;
    this.style.display = "none";
    seeLessBtn.style.display = "block";
  });

  seeLessBtn.addEventListener("click", function() {
    textContainer.innerHTML = previewText;
    this.style.display = "none";
    seeMoreBtn.style.display = "block";
  });
});


  } catch(e) { console.error(e); }
})();
})();
